/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import {
  SET_MACHINE_SEARCH_VALUE,
  SET_MACHINE_CURRENT_SELECTION,
  SET_MACHINE_CURRENT_NAME,
  SET_MACHINE_CURRENT_SELECTED_TAB
} from "./types"

export const initialSelection = {
  id: '',
  clientId: '',
  subjectId: '',
  realmName: '',
  realmId: '',
  displayName: '',
  isUberRealmClient: true,
};

export const machineReducerInitialState: any = {
  searchValue: '',
  currentSelection: '',
  currentName: '',
  currentSelectedTab: null
};

export const machineReducer = (state = machineReducerInitialState, action: any) => {
  switch (action.type) {
    case SET_MACHINE_SEARCH_VALUE:
      return {
        ...state,
        searchValue: action.searchValue,
      }
    case SET_MACHINE_CURRENT_NAME:
      return {
        ...state,
        currentName: action.currentName,
      }
    case SET_MACHINE_CURRENT_SELECTION:
      return {
        ...state,
        currentSelection: action.currentSelection,
        currentName: action.currentSelection?.displayName || '',
      }
    case SET_MACHINE_CURRENT_SELECTED_TAB:
      return {
        ...state,
        currentSelectedTab: action.currentSelectedTab,
      }
    default:
      return state
  }
};